export default __webpack_public_path__ + "static/ph-2f877f2da1b5b9bf8baad4e8d259d774.svg";